import { ENV_TYPES } from "../../components/global/Sidebar";
import { apiSlice } from "../createApiSlice";

const API_BASE = "/import";
const buildUrl = (endpoint) => API_BASE + endpoint;

export const uploadApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        uploadImport: builder.mutation({
            query: (args) => {
                const { source, type, file } = args;
                const formData = new FormData();
                formData.append('file', file);

                return {
                    url: buildUrl(`/preprocess/${source}/${type}`),
                    method: 'POST',
                    body: formData,
                };
            },
        }),
        processImport: builder.mutation({
            query: (args) => {
                const { source, type, data } = args;
                return {
                    url: buildUrl(`/process/${source}/${type}`),
                    method: 'POST',
                    body: data,
                };
            },
        }),
        uploadLogo: builder.mutation({
            query: (args) => {
                const { file } = args;
                const formData = new FormData();
                formData.append('file', file);


                return {
                    url: buildUrl(`/logo`),
                    method: 'POST',
                    body: formData,
                    headers: args.headers
                };
            },
        }),
        fullImport: builder.mutation({
            query: (args) => {
                const { type, file } = args;
                const formData = new FormData();
                formData.append('file', file);

                return {
                    url: buildUrl(`/fullimport/${type}`),
                    method: 'POST',
                    body: formData,
                };
            },
        }),
        singleImport: builder.mutation({
            query: (args) => {
                const { type, file, ...queryParams } = args;
                const formData = new FormData();
                formData.append('file', file);

                // Build query string from remaining args. A structured value, such as the
                // naheffingen import options, travels in the body as JSON: a URL has no room for it.
                const params = new URLSearchParams();
                Object.entries(queryParams).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) {
                        if (typeof value === "object") {
                            formData.append(key, JSON.stringify(value));
                        } else {
                            params.append(key, value);
                        }
                    }
                });
                const queryString = params.toString();
                const url = queryString
                    ? `${buildUrl(`/singleimport/${type}`)}?${queryString}`
                    : buildUrl(`/singleimport/${type}`);

                return {
                    url,
                    method: 'POST',
                    body: formData,
                };
            },
            // The naheffingen import stores its options as a setting, so the stored options
            // shown on the next import are refetched. The tarieven import adds categories and
            // changes their prices. The voorraad verplaatsen import moves stock to other locations.
            invalidatesTags: (result, error, args) => {
                if (args?.type === "naheffingen") return [{ type: 'Settings', key: 'adjustmentcharges' }];
                if (args?.type === "tariefcategorieen") return [{ type: 'InvoiceCategories' }, { type: 'InvoiceProducts' }];
                if (args?.type === "voorraadverplaatsen") return [{ type: 'Stock' }, { type: 'StockForProduct' }];
                return [];
            },
        }),
        // The naheffingen import options of a shipper, stored without importing a file.
        saveAdjustmentChargeOptions: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/adjustmentcharges/options`),
                method: 'PUT',
                body,
            }),
            invalidatesTags: () => [{ type: 'Settings', key: 'adjustmentcharges' }],
        }),
    })
});

export const { 
    useUploadImportMutation,
    useProcessImportMutation,
    useUploadLogoMutation,
    useFullImportMutation,
    useSingleImportMutation,
    useSaveAdjustmentChargeOptionsMutation
} = uploadApiSlice;


// base: "#31415f",
// background: "#ecf0f5",
// streamrule: "#ced7e1",
// streamrulehover: "#8E96A7",
// streamrulevalue: "#ecf0f5",
// streamrulevaluetxtcolor: "#8E96A7",
// streamrulevaluehover: "#8E96A7",